var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item && _vm.item.length > 0)?_c('div',{staticClass:"marqueetext"},[_c('p',[_vm._v(_vm._s(_vm.item[0].MaintainenceAlert))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.item[0].MaintainenceAlert))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ae7aa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/marquee.vue
// module id = null
// module chunks = 